export const accentColors = {
  accentOne: '#92ACCD',
  accentTwo: '#F4C3B4',
  accentThree: '#F3AB74',
  accentFour: '#BDCEBE',
} as const;
